/**
 * Trade Types Module
 */
(function(){
    'use strict';

    angular.module('elogbooks.admin.trade-types', []);
})();
